export default __webpack_public_path__ + "static/media/offer2.51d061f5.jpg";